export const ACCOUNT_DISPLAY_NAME_MIN = 2
export const ACCOUNT_DISPLAY_NAME_MAX = 80

export const normalizeAccountDisplayName = value =>
  String(value || '')
    .replace(/\s+/g, ' ')
    .trim()

const looksLikeEmail = value =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim())

export const getOwnDisplayNameError = value => {
  const name = normalizeAccountDisplayName(value)
  if (!name) return 'Please enter your name.'
  if (name.length < ACCOUNT_DISPLAY_NAME_MIN) {
    return `Name must be at least ${ACCOUNT_DISPLAY_NAME_MIN} characters.`
  }
  if (name.length > ACCOUNT_DISPLAY_NAME_MAX) {
    return `Name must be ${ACCOUNT_DISPLAY_NAME_MAX} characters or fewer.`
  }
  if (looksLikeEmail(name)) return 'Use your name, not an email address.'
  return null
}
